<template>
  <div id="app" class="container-fluid">
    <transition>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import VueFormWizard from 'vue-form-wizard'
import VueSignature from "vue-signature-pad";

import '@/assets/styles/main.scss'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

Vue.use(VueSignature);
Vue.config.productionTip = false;

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Vuelidate)
Vue.use(VueFormWizard)

export default {
  name: 'App',
  components: {
  },
}
</script>

